// 🩺 치과 「오늘」 — "장착 후 확인 — 확인 필요 N건" 카드 (2026-10-02 대표 승인, 플래그 patientFeedback strict)
// 기획 docs/기획서_환자피드백_2026-10-01.md v2 §4-3 · 서버 계약 docs/계약_장착후확인_서버_2026-10-02.md §B-5 (bucket need_check)
//  - 부모(ClinicToday)가 플래그 ON일 때만 마운트 → OFF면 listClinicFeedbacks 호출 0
//  - 0건이고 오류도 없으면 카드 자체를 숨긴다(ClinicSelfRegisterCard 와 같은 규칙)
//  - 카드 클릭 → 목록 모달: 환자명 · 항목(치식+종류) · 시점 · 불편 문항 제목 · 답한 시각. 답 값·자유 서술은 없다(의뢰서 카드에서만)
//  - [확인함]은 모달에 두지 않는다 — 의뢰서에서 내용을 본 뒤 누르게 한다. 인쇄·복사·내보내기 없음
//  - 콘솔에 환자명 기록 금지 — 오류는 코드만
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck, X } from 'lucide-react';
import { listClinicFeedbacks, describeFeedbackError, pointLabel, itemLabel, fmtMs } from '../../services/clinicFeedbackApi';

function ClinicFeedbackNeedCard() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [truncated, setTruncated] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [err, setErr] = useState('');
    const [open, setOpen] = useState(false);

    const load = useCallback(async () => {
        setErr('');
        try {
            const r = await listClinicFeedbacks('need_check');
            setRows(Array.isArray(r?.items) ? r.items : []);
            setTruncated(r?.truncated === true);
        } catch (e) {
            setErr(describeFeedbackError(e, '장착 후 확인 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'));
        } finally { setLoaded(true); }
    }, []);

    useEffect(() => { load(); }, [load]);

    if (!loaded || (rows.length === 0 && !err)) return null;

    return (
        <>
            <div style={S.card}>
                <div style={S.head}>
                    <div style={S.iconBox}><ClipboardCheck size={18} color="#fff" /></div>
                    <button type="button" onClick={() => rows.length && setOpen(true)} style={S.titleBtn} disabled={rows.length === 0}>
                        <div style={S.title}>{'장착 후 확인 — 확인 필요 '}<span style={{ color: '#dc2626' }}>{`${rows.length}${truncated ? '+' : ''}건`}</span></div>
                        <div style={S.notice}>환자가 앱에서 "불편해요/네"로 답한 회신입니다. 눌러서 목록을 보고, 의뢰서에서 내용을 확인해 주세요.</div>
                    </button>
                    <button type="button" onClick={load} style={S.chip}>새로 고침</button>
                </div>
                {err && <div style={S.err}>{err}</div>}
            </div>

            {open && (
                <div style={S.overlay} onClick={() => setOpen(false)}>
                    <div style={S.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                            <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>{`장착 후 확인 — 확인 필요 ${rows.length}건`}</span>
                            <button type="button" onClick={() => setOpen(false)} style={{ ...S.chip, marginLeft: 'auto', padding: '4px 8px' }} aria-label="닫기"><X size={14} /></button>
                        </div>
                        <div style={S.rows}>
                            {rows.map(r => (
                                <div key={r.fbId} style={S.row}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                        <span style={S.name}>{String(r.name || '').trim() || '(이름 없음)'}</span>
                                        <span style={S.point}>{pointLabel(r.point)}</span>
                                        {(r.items || []).map(it => <span key={it.itemId} style={S.itemChip}>{itemLabel(it)}</span>)}
                                    </div>
                                    {(r.flaggedQuestions || []).length > 0 && (
                                        <div style={S.qs}>{(r.flaggedQuestions || []).map(q => q.label).join(' · ')}</div>
                                    )}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                        <span style={S.sub}>{r.answeredAt ? `회신 ${fmtMs(r.answeredAt, true)}` : ''}</span>
                                        {r.orderId && <button type="button" onClick={() => navigate(`/view-order/${r.orderId}`)} style={{ ...S.btnP, marginLeft: 'auto' }}>의뢰서에서 확인</button>}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {truncated && <div style={S.sub}>최근 300건까지만 표시합니다.</div>}
                    </div>
                </div>
            )}
        </>
    );
}

const S = {
    card: { background: '#fff', border: '1px solid #fecaca', borderRadius: 12, padding: '14px 16px', marginBottom: 14, userSelect: 'none' },
    head: { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' },
    iconBox: { width: 36, height: 36, borderRadius: 10, background: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    titleBtn: { flex: 1, minWidth: 200, textAlign: 'left', background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: 'inherit' },
    title: { fontSize: 15, fontWeight: 700, color: '#0f172a' },
    notice: { fontSize: 12, color: '#64748b', marginTop: 2, lineHeight: 1.5 },
    chip: { display: 'inline-flex', alignItems: 'center', padding: '6px 12px', fontSize: 12.5, border: '1px solid #e2e8f0', borderRadius: 8, background: '#fff', color: '#475569', cursor: 'pointer' },
    err: { marginTop: 10, background: '#fdecec', border: '1px solid #f5cfcf', color: '#8a2020', borderRadius: 8, padding: '8px 11px', fontSize: 12.5 },
    overlay: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
    modal: { background: '#fff', borderRadius: 12, padding: '16px 18px', width: '100%', maxWidth: 560, maxHeight: '80vh', overflowY: 'auto', userSelect: 'none' },
    rows: { display: 'flex', flexDirection: 'column' },
    row: { padding: '10px 4px', borderBottom: '1px solid #f1f5f9', fontSize: 14 },
    name: { fontWeight: 700, color: '#0f172a', fontSize: 15 },
    point: { fontSize: 12, fontWeight: 700, color: '#b91c1c', background: '#fee2e2', borderRadius: 999, padding: '2px 8px' },
    itemChip: { fontSize: 12, fontWeight: 600, color: '#334155', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 999, padding: '2px 8px' },
    qs: { fontSize: 13, color: '#b91c1c', marginTop: 4 },
    sub: { color: '#64748b', fontSize: 12.5 },
    btnP: { padding: '5px 12px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
};

export default ClinicFeedbackNeedCard;
